import { render, staticRenderFns } from "./ChooseFile.vue?vue&type=template&id=68c717ec&scoped=true"
import script from "./ChooseFile.vue?vue&type=script&lang=ts"
export * from "./ChooseFile.vue?vue&type=script&lang=ts"
import style0 from "./ChooseFile.vue?vue&type=style&index=0&id=68c717ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c717ec",
  null
  
)

export default component.exports